import { EBuildingCraneType } from '../../../../json_query';
import { IBuildingCraneTypesTag } from '../../../state/tags/definitions/building_crane';
import { getMultiSelectionParamTagItem } from './fabrics/multi_selection_param_tag';

const buildingCraneMap = {
  [EBuildingCraneType.Overhead]: 'Мостовой кран',
  [EBuildingCraneType.Beam]: 'Кран-балка',
  [EBuildingCraneType.Railway]: 'Ж/д кран',
  [EBuildingCraneType.Goat]: 'Козловой кран',
};

export const BuildingCraneTypesTagItem = getMultiSelectionParamTagItem<EBuildingCraneType, IBuildingCraneTypesTag>(
  buildingCraneMap,
);
